import { gql } from "@apollo/client";

export const CREATE_APPLICATION = gql`
  mutation createApplication($decisionId: String!) {
    decisions {
      data: createApplication(decisionUuid: $decisionId) {
        uuid
      }
    }
  }
`;
